export default {
      id: "error_outline-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#error_outline",
      toString: function () {
        return this.url;
      }
    }